var map = {
	"./cloud_infrastructure.svg": 95,
	"./codeInLogo.png": 96,
	"./contactMail.png": 49,
	"./data_science.svg": 97,
	"./datacamp.png": 98,
	"./developerActivity.svg": 99,
	"./education.svg": 38,
	"./experience.svg": 100,
	"./fullstack.svg": 101,
	"./gcp_logo.png": 102,
	"./googleAssistant.jpg": 103,
	"./googleAssistant.svg": 104,
	"./google_logo.png": 105,
	"./ibm_logo.png": 106,
	"./imb.jpg": 107,
	"./internshala.png": 108,
	"./jsFramework.svg": 109,
	"./manOnTable.svg": 47,
	"./mongo.png": 110,
	"./nextuLogo.jpg": 111,
	"./portfolio.gif": 112,
	"./programmer.svg": 113,
	"./pwa.png": 114,
	"./saayaHealthLogo.png": 115,
	"./skill.svg": 50,
	"./talksCardBack.svg": 116,
	"./talksCardBackAlt.svg": 117,
	"./udemy.png": 118,
	"./ui_ux_design.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;